module.exports = __webpack_public_path__ + "static/media/home-owner.2b08014d.svg";